document.addEventListener("DOMContentLoaded", async () => {
  console.log("🟡 achat.js started");

  // --- 🔹 Language detection ---
  const isArabic = window.location.pathname.includes("/ar/pages/achat");

  if (isArabic) {
    console.log("🌙 Arabic version detected");

    document.querySelector(".achat-hero h1").innerHTML = `شكراً على شرائك <span class="emoji">💎</span>`;
    document.querySelector(".achat-hero p").textContent =
      "لقد تم استلام طلبك وسيتم تحضيره قريباً.";

    document.querySelector(".achat-summary-card h2").textContent = "تفاصيل الطلب";
    const labels = document.querySelectorAll(".achat-summary-grid div strong");
    const arabicLabels = ["الاسم:", "الهاتف:", "الولاية:", "البلدية:", "العنوان:", "التوصيل:"];
    labels.forEach((el, i) => (el.textContent = arabicLabels[i] || el.textContent));
    document.getElementById("shippingMethod").textContent = "توصيل مجاني إلى المنزل";

    document.querySelector(".achat-product-card h2").textContent = "المنتج المطلوب";
    const productInfo = document.querySelector(".achat-product-info");
    if (productInfo) {
      productInfo.innerHTML = `
        <p><strong>المنتج :</strong> <span id="productName"></span></p>
        <p><strong>الكمية :</strong> <span id="productQuantity"></span></p>
        <p><strong>السعر :</strong> <span id="totalPrice"></span></p>
      `;
    }

    // Replace policy section (your <ul> + <p>)
    const policySection = document.querySelector(".achat-policy");
    policySection.innerHTML = `
    <h2>سياسة الإرجاع</h2>
    <p>نقبل الإرجاع وفق الشروط التالية:</p>

    <ul>
      <li>✔️ <strong>الحالة 1 : المنتج غير مفتوح</strong><br>
      يجب أن يكون العطر غير مُستعمل، غير مفتوح، وفي عبوته الأصلية.<br>
      ➡️ يتم تعويضك بالكامل بعد استلام المنتج وفحصه.</li>

      <li>✔️ <strong>الحالة 2 : المنتج مفتوح لكن غير مستعمل </strong><br>
      إذا تم فتح العطر ولكن بقي في حالة جديدة:<br>
      ➡️ يتم خصم مبلغ <strong>5000 دج</strong> من التعويض بسبب عدم إمكانية إعادة بيع المنتج المفتوح.</li>

      <li>❌ <strong>الحالة 3 : المنتج مستعمل بوضوح</strong><br>
      يتم رفض الإرجاع إذا كان مستوى العطر منقوصاً بوضوح أو العبوة متضررة بشكل كبير.</li>

      <li>🧳 <strong>ملاحظة حول التغليف</strong><br>
      قد يكون هناك أحياناً خدوش أو تلف بسيط في علبة العطر لأنه يتم استيراد المنتجات في حقائب سفر.</li>
    </ul>

    <h3>كيفية التواصل معنا</h3>
    <ul>
      <li>🌐 عبر موقعنا: <a href="/ar/pages/contact" class="achat-contact-link"><strong>نموذج الاتصال</strong></a></li>
      <li>📩 البريد الإلكتروني: <a href="mailto:contact@onlypremiumdz.com" class="achat-email-link"><strong>contact@onlypremiumdz.com</strong></a></li>
      <li>💬 عبر مواقع التواصل :
        <a href="https://www.facebook.com/profile.php?id=61556134383998" target="_blank" class="achat-social-link">Facebook</a>&nbsp;&nbsp;
      </li>
    </ul>

    <p>سنعمل على الرد عليك في أقرب وقت لإيجاد الحل الأنسب لك.</p>
  `;

    
    //<li>📱 عبر الرسائل النصية فقط (بدون مكالمات): 39 99 71 542 213+</li>
    

    /*if (isArabic) {
  document.getElementById("downloadPdfBtn").textContent = "📄 تحميل ملخص الطلب";
}*/

    document.querySelector(".achat-continue").innerHTML =
  '<a href="/ar/collections/all" class="achat-continue-btn luxoradz-btn">مواصلة التسوق 🛒</a>';

    document.querySelector(".achat-footer p").innerHTML =
      "شكراً لاختيارك <strong>Only Premium</strong> 💖";

    // Optional: right-align Arabic text
    document.querySelector(".achat-page").setAttribute("dir", "rtl");
    document.querySelector(".achat-page").style.textAlign = "right";
  }

  // --- Helper: wait until a condition is true ---
  async function waitUntil(conditionFn, maxTries = 30, delay = 200) {
    for (let i = 0; i < maxTries; i++) {
      const result = conditionFn();
      if (result) return result;
      await new Promise((r) => setTimeout(r, delay));
    }
    return null;
  }
  
  

  // --- Extract URL safely ---
  let query = window.location.search;
  await waitUntil(() => query.includes("product_url") || query.includes("product="));

  const params = new URLSearchParams(window.location.search);

  // --- Robust helper for full product name param ---
  function extractFullParam(name) {
    const regex = new RegExp(`${name}=([^&]+(?:&(?!quantity=|product_url=)[^&=]+)*)`);
    const match = query.match(regex);
    return match ? decodeURIComponent(match[1].replace(/\+/g, " ")) : "";
  }

  // --- Wait for product_url param (Shopify sometimes delays it) ---
  const productUrlRaw = await waitUntil(() => params.get("product_url"));

  const name = params.get("name") || "";
  const phone = params.get("phone") || "";
  const address = params.get("address") || "";
  const province = params.get("province") || "";
  const city = params.get("city") || "";
  const product = extractFullParam("product") || "Produit inconnu";
  const quantityRaw = params.get("quantity") || "1";
  const quantity = quantityRaw.trim().split(/\s+/)[0].replace(/[^\d]/g, "") || "1";
  //const randomNumber = "#LUX" + Math.floor(100000 + Math.random() * 900000);
  const total = params.get("total") || "";

  // --- Fill info ---
  //document.getElementById("orderNumber").textContent = randomNumber;
  document.getElementById("customerName").textContent = name;
  document.getElementById("customerPhone").textContent = phone;
  document.getElementById("customerAddress").textContent = address;
  document.getElementById("customerProvince").textContent = province;
  document.getElementById("customerCity").textContent = city;
  document.getElementById("productName").textContent = product;
  document.getElementById("productQuantity").textContent = "× " + quantity;
  document.getElementById("totalPrice").textContent = total;

  // --- Product Image ---
  const productImage = document.getElementById("productImage");

  async function loadProductImage(url) {
    const jsonUrl = url.split("?")[0] + ".json";
    try {
      console.log("🔗 Fetching product JSON:", jsonUrl);
      const res = await fetch(jsonUrl, { cache: "no-store" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      const imageSrc = data?.product?.images?.[0]?.src;
      if (!imageSrc) throw new Error("No image found");

      // Wait until image fully loads visually
      await new Promise((resolve, reject) => {
        const img = new Image();
        img.src = imageSrc;
        img.onload = resolve;
        img.onerror = reject;
      });

      productImage.src = imageSrc;
      productImage.alt = data.product.title || product;
      productImage.style.filter = "none";
      productImage.style.opacity = "1";
      console.log("✅ Image loaded successfully");
    } catch (err) {
      console.error("⚠️ Product image failed:", err);
      productImage.alt = "Image non disponible";
    }
  }

  // Wait and retry image loading up to 5 times
  let retries = 0;
  const maxRetries = 250;
  let productUrl = decodeURIComponent(productUrlRaw || "");

  while ((!productUrl || !productUrl.includes("/products/")) && retries < maxRetries) {
    console.warn("⏳ Waiting for valid product_url...");
    await new Promise((r) => setTimeout(r, 800));
    productUrl = decodeURIComponent(params.get("product_url") || "");
    retries++;
  }

  if (productUrl) {
    await loadProductImage(productUrl);
  } else {
    console.error("❌ No product URL available after retries");
  }

  // --- Fade-in animation ---
  requestAnimationFrame(() => {
    document.querySelectorAll(".fade-in-up").forEach((el, i) => {
      setTimeout(() => el.classList.add("visible"), i * 200);
    });
  });

  // --- PDF Download ---
document.getElementById("downloadPdfBtn")?.addEventListener("click", () => {
  const params = new URLSearchParams(window.location.search);
  const realOrderId = params.get("id") || "#LUX-" + Math.floor(100000 + Math.random() * 900000);

  const order = {
    id: realOrderId,
    name: document.getElementById("customerName")?.textContent || "",
    phone: document.getElementById("customerPhone")?.textContent || "",
    address: document.getElementById("customerAddress")?.textContent || "",
    city: document.getElementById("customerCity")?.textContent || "",
    product: document.getElementById("productName")?.textContent || "",
    quantity: document.getElementById("productQuantity")?.textContent || "",
  };

  const docDefinition = {
    info: { title: `Commande ${order.id} - Luxoradz` },
    content: [
      { text: "💎 Luxoradz.com", style: "header", alignment: "center", margin: [0, 0, 0, 20] },
      { text: "Résumé de la commande", style: "title" },
      {
        style: "section",
        table: {
          widths: ["auto", "*"],
          body: [
            ["Commande n°:", order.id],
            ["Nom:", order.name],
            ["Téléphone:", order.phone],
            ["Adresse:", order.address],
            ["Ville:", order.city],
          ],
        },
        layout: "noBorders",
      },
      { text: "Détails du produit", style: "title", margin: [0, 15, 0, 5] },
      {
        ul: [
          `Produit: ${order.product}`,
          `Quantité: ${order.quantity}`,
          "Livraison: Gratuite à domicile 🚚",
        ],
      },
      {
        text: "Merci d’avoir choisi Only Premium 💛",
        style: "footer",
        alignment: "center",
        margin: [0, 30, 0, 0],
      },
    ],
    styles: {
      header: { fontSize: 20, bold: true, color: "#b58b23" },
      title: { fontSize: 14, bold: true, color: "#333", margin: [0, 10, 0, 6] },
      section: { fontSize: 12, color: "#444" },
      footer: { fontSize: 12, italics: true, color: "#b58b23" },
    },
    defaultStyle: { font: "Roboto" },
  };

  pdfMake.createPdf(docDefinition).download(`Commande_${order.id}.pdf`);
});
  
  
 // ✅ Auto-refresh once per session
if (!sessionStorage.getItem("achat_refreshed")) {
  sessionStorage.setItem("achat_refreshed", "true");
  console.log("♻️ Auto-refreshing once to fix delayed render");
  window.location.reload();
} else {
  // ✅ Confetti runs AFTER refresh only
  const confettiShown = sessionStorage.getItem("confetti_once");
  if (!confettiShown) {
    sessionStorage.setItem("confetti_once", "true");

    const container = document.createElement("div");
    container.className = "confetti-container";
    document.body.appendChild(container);

    const colors = ["#f8e5a7", "#d4af37", "#fff6d6", "#e7c469"];
    for (let i = 0; i < 70; i++) {
      const c = document.createElement("div");
      c.className = "confetto";
      c.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      c.style.left = Math.random() * 100 + "vw";
      c.style.top = Math.random() * 20 + "vh"; // start from a bit lower for variety
      c.style.animationDelay = Math.random() * 0.5 + "s";
      c.style.animationDuration = 3 + Math.random() * 2 + "s";
      c.style.setProperty("--x-move", (Math.random() - 0.5) * 200 + "px"); // random horizontal drift
      c.style.setProperty("--y-move", "100vh"); // fall distance
      container.appendChild(c);
    }

    // Remove after 5 seconds
    setTimeout(() => container.remove(), 5000);
  }
}
});

async function setProductRecommendationId() {
  try {
    const params = new URLSearchParams(window.location.search);
    const productUrl = params.get("product_url");
    if (!productUrl) return console.warn("⚠️ No product_url parameter found in URL");

    console.log("🔗 Fetching product JSON:", productUrl + ".json");
    const res = await fetch(productUrl + ".json");
    const data = await res.json();

    const productId = data.product.id;
    console.log("✅ Product ID set to:", productId);

    const recommendations = document.querySelector("product-recommendations");
    if (!recommendations) return console.warn("⚠️ No <product-recommendations> element found on page");

    // Update ID
    recommendations.dataset.productId = productId;

    // Build the recommendations URL manually
    const sectionId = recommendations.dataset.sectionId;
    const intent = recommendations.dataset.intent || "related";
    const limit = 4; // You can adjust this if needed

    const newUrl = `/recommendations/products?limit=${limit}&product_id=${productId}&section_id=${sectionId}&intent=${intent}`;
    console.log("🔁 Reloading recommendations:", newUrl);

    const response = await fetch(newUrl);
    if (!response.ok) throw new Error("Failed to fetch recommendations: " + response.status);

    const html = await response.text();

    // Parse new recommendations HTML and replace content
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const newSection = tempDiv.querySelector("product-recommendations");
    if (newSection) {
      recommendations.innerHTML = newSection.innerHTML;
      console.log("✅ Recommendations successfully refreshed");
    } else {
      console.warn("⚠️ No recommendations returned from server");
    }

  } catch (err) {
    console.error("❌ Error setting and refreshing recommendations:", err);
  }
}

document.addEventListener("DOMContentLoaded", setProductRecommendationId);